import ReactAutosuggest from "react-autosuggest";
import React, { Component } from "react";
import { Input } from "reactstrap";
import style from "./Autosuggest.module.scss";
import { debounce } from "../../utils/Helper";

const theme = {
  suggestionsContainer: style.suggestionsContainer,
  suggestionsContainerOpen: style.suggestionsContainerOpen,
  suggestionsList: style.suggestionsList,
  suggestionHighlighted: style.suggestionHighlighted,
  suggestion: style.suggestion,
  input: style.input,
};

class Autosuggest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      selected: props.value !== undefined,
      suggestions: [],
    };

    this.onChange = this.onChange.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onSuggestionsFetchRequested = debounce(this.onSuggestionsFetchRequested.bind(this), 300);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.shouldRenderSuggestions = this.shouldRenderSuggestions.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.value != nextState.value) {
      this.setState({ value: nextState.value });
    } else if (this.props.value != nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  onChange(event, { newValue, method }) {
    if (method == "up" || method == "down") return;

    if (method !== "click" && method !== "enter") {
      this.props.onChange(method, newValue);
    }

    this.setState({
      value: newValue,
      selected: method == "enter" || method == "click",
    });
  }

  onSuggestionSelected(event, { suggestion, method }) {
    this.props.onChange(method, suggestion);
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested({ value, reason }) {
    if (reason == "input-focused") {
      if (this.state.selected) {
        return;
      }
    }

    this.setState({ loading: true });

    this.props.onSuggestionsFetchRequested({ value }).then((suggestions) => {
      this.setState({
        suggestions,
        loading: false,
      });
    });
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested() {
    this.setState({
      suggestions: [],
    });
  }

  shouldRenderSuggestions(value) {
    return value.length > 0;
  }

  render() {
    const { value, suggestions } = this.state;
    const inlineStyle = this.props.style || {};
    const inputProps = {
      ...this.props.inputProps,
      value,
      onChange: this.onChange,
    };
    return (
      <div style={{ position: "relative", ...inlineStyle }}>
        <ReactAutosuggest
          theme={theme}
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionSelected={this.onSuggestionSelected}
          shouldRenderSuggestions={this.shouldRenderSuggestions}
          getSuggestionValue={this.props.getSuggestionValue}
          renderSuggestion={this.props.renderSuggestion}
          focusInputOnSuggestionClick={false}
          renderInputComponent={(inputProps) => <Input {...inputProps} />}
          inputProps={inputProps}
          alwaysRenderSuggestions={false}
        />
        {this.state.loading && <div className={style.loading}></div>}
      </div>
    );
  }
}

export default Autosuggest;
